import styled from "styled-components"
import { ActionDropdownButton } from "../../../../Ui/Buttons/ActionDropdownButton"

export const Container = styled.div`
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  background: ${(p) => p.theme.colors.white};
  border-radius: 0.5rem;
  padding: 1.5rem 2rem;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    padding: 2.5rem 3rem;
  }
`

export const ActionContainer = styled.div`
  padding: 1rem;
  border-radius: 0.6rem;
  border: 0.1rem solid ${p => p.theme.colors.borderLight};
  margin-bottom: 1rem;
`

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${p => p.theme.colors.white};
  align-items: center;

  button {
    height: 3rem;
  }

  svg {
    height: 2rem;
    margin-right: 1rem;
  }
`

export const InputWrapper = styled.div`
display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`

export const InputContainer = styled.div`
margin-top: 1.5rem;
`

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const InfoWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 7fr;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  align-items: center;
  p {
    display: inline-block;
    word-break: break-word;
    font-size: 1.1rem;
    margin: 0.5rem;
  }
`

export const GiftCardInputWrapper = styled.div`
display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  margin: 1.5rem 0 0.5rem 0;

  p {
    margin: 0;
    font-size: 1.1rem;
  }
`

export const StyledActionDropdownButton = styled(ActionDropdownButton)`
background: aliceblue;

`

export const ButtonWrapper = styled.div`
 padding-top: 1rem;
  margin-top: 2rem;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  border-top: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  button {
    margin-left: 1rem;
  }
`
